module.exports = __webpack_public_path__ + "img/coinbankB09.8edb6f19.jpg";